import { AnyAction } from "redux";
import {
  CLEAR_ACTIVE_DASHBOARD_ID,
  SET_ACTIVE_DASHBOARD_ID
} from "../actions/activeDashboard";

export const activeDashboard = (state = 0, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_DASHBOARD_ID:
      return action.id as number;
    case CLEAR_ACTIVE_DASHBOARD_ID:
      return 0;
    default:
      return state;
  }
};

export default activeDashboard;
